import React, { useState, useEffect } from 'react';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title,
  CategoryScale,
  LinearScale
} from 'chart.js';

// Register necessary chart elements
ChartJS.register(ArcElement, Tooltip, Legend, Title, CategoryScale, LinearScale);

const DepartmentFilter = ({ selectedDepartment, handleDepartmentChange }) => {
    const [departments, setDepartments] = useState([]);
    const [publicationTypeCounts, setPublicationTypeCounts] = useState({});

    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/departments`);
                const data = await response.json();
                setDepartments(data);
            } catch (error) {
                console.error('Error fetching departments:', error);
            }
        };
        fetchDepartments();
    }, []);

    const fetchPublicationCounts = async (deptId) => {
        try {
            const url = deptId
                ? `${process.env.REACT_APP_API_BASE_URL}/api/publications/countsbypublicationtype?deptId=${deptId}`
                : `${process.env.REACT_APP_API_BASE_URL}/api/publications/countsbypublicationtype`;

            const response = await fetch(url);
            const data = await response.json();

            // **Fix 1: Remove Empty Labels**
            const filteredData = {};
            Object.keys(data).forEach((key) => {
                if (key.trim() !== "") {
                    filteredData[key.toUpperCase()] = data[key];
                }
            });

            setPublicationTypeCounts(filteredData);
        } catch (error) {
            console.error('Error fetching publication counts:', error);
        }
    };

    useEffect(() => {
        fetchPublicationCounts(); // Fetch counts for all publications on initial load
    }, []);

    useEffect(() => {
        if (selectedDepartment) {
            fetchPublicationCounts(selectedDepartment);
        }
    }, [selectedDepartment]);

    const PieChart = ({ publicationTypeCounts }) => {
        const labels = Object.keys(publicationTypeCounts);
        const values = Object.values(publicationTypeCounts);

        const data = {
            labels,
            datasets: [
                {
                    data: values,
                    backgroundColor: [
                        '#FF6384', '#36A2EB', '#FFCE56', '#FF9F40', '#4BC0C0',
                        '#9966FF', '#C9CBCF', '#FFCD56', '#4BC0C0', '#FF9F40',
                        '#B36AE2', '#FFD700', '#6AE289', '#E2896A', '#6A89E2'
                    ], // **Fix 3: Extended color array**
                },
            ],
        };

        const options = {
            maintainAspectRatio: false,
            plugins: {
                tooltip: {
                    enabled: true,
                    callbacks: {
                        label: function (tooltipItem) {
                            const value = tooltipItem.raw;
                            const total = values.reduce((acc, num) => acc + num, 0);
                            const percentage = ((value / total) * 100).toFixed(2);
                            return `${tooltipItem.label}: ${value} (${percentage}%)`;
                        },
                    },
                },
                legend: {
                    position: 'left',
                    align: 'start',
                },
            },
            layout: {
                padding: { left: 50 },
            },
        };

        return (
            <div className="pie-chart">
                <Pie data={data} options={options} />
            </div>
        );
    };

    return (
        <div className="department-filter row">
            <div className="col-5">
                <label htmlFor="department" className="form-label">Select Department:</label>
            </div>
            <div className="col-7">
                <select
                    id="department"
                    value={selectedDepartment}
                    onChange={handleDepartmentChange}
                    className="form-select mb-3"
                >
                    <option value="">Select a Department</option>
                    {departments.map((dept) => (
                        <option key={dept.deptId} value={dept.deptId}>
                            {dept.deptName}
                        </option>
                    ))}
                </select>
            </div>
            <PieChart publicationTypeCounts={publicationTypeCounts} />
        </div>
    );
};

export default DepartmentFilter;
